import classNames from 'classnames/bind'
import { HTMLAttributes, ReactNode } from 'react'

// Styles
import styles from './style.module.scss'
const cx = classNames.bind(styles)

const LiveSectionTitle = ({
  icon,
  children,
  className,
  ...props
}: HTMLAttributes<HTMLDivElement> & {
  icon?: ReactNode
}) => {
  return (
    <div className={cx('live-section-title', className)} {...props}>
      {icon}
      {children}
    </div>
  )
}

export default LiveSectionTitle
